import { render, staticRenderFns } from "./import-sisterQuestion.vue?vue&type=template&id=7f7ff2f6&scoped=true&"
import script from "./import-sisterQuestion.vue?vue&type=script&lang=ts&"
export * from "./import-sisterQuestion.vue?vue&type=script&lang=ts&"
import style0 from "./import-sisterQuestion.vue?vue&type=style&index=0&id=7f7ff2f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7ff2f6",
  null
  
)

export default component.exports